import { RootState } from "../../../RootReducer";

export const selectActiveItinerary = (state: RootState) => state.mapPage.activeDestination.activeItinerary;
